import { getData } from "../apiClient";

export const GetAll = async (
  { month = "", year = "" },
  signal = null
) => {
  const queryParams = new URLSearchParams({ month, year });
  return await getData(
    `/statistics/monthly?${queryParams.toString()}`,
    {},
    {},
    signal
  );
};